module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/engine-user-agent.js
// module id = 1176
// module chunks = 0